import { FAQSecWrapper } from "../../styles/StyledComponents/FAQSecWrapper";
import { accordianMockData } from "../../ui/json/demo.mock";
import CustomAccordion from "../CustomAccordion/CustomAccordion";

const FAQSec = () => {
  return (
    <FAQSecWrapper className="cmn_gap_btm">
      <div className="container">
        <div className="row faq_row">
          <div className="cmn_faq_col faq_leftCOl">
            <h2>Frequently Answered Questions</h2>
          </div>
          <div className="cmn_faq_col faq_rightCOl">
            <CustomAccordion items={accordianMockData} />
          </div>
        </div>
      </div>
    </FAQSecWrapper>
  );
};

export default FAQSec;
